export default function ContactSection() {
  return (
    <section
      id="contact"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50 scroll-mt-16"
    >
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
          联系我们
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>
        <p className="mt-6 text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto">
          如遇到播放问题、内容建议或有意向合作，欢迎通过以下方式与我们取得联系。人人影视团队将尽快回复您的反馈。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8">
          <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-background-100 cursor-pointer hover:bg-background-200/70 transition-colors">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
              <i className="ri-mail-line text-lg"></i>
            </div>
            <div className="text-left">
              <span className="text-xs text-foreground-500">意见反馈</span>
              <p className="text-sm font-medium text-foreground-800">feedback@rrtv.com</p>
            </div>
          </div>

          <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-background-100 cursor-pointer hover:bg-background-200/70 transition-colors">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
              <i className="ri-chat-3-line text-lg"></i>
            </div>
            <div className="text-left">
              <span className="text-xs text-foreground-500">内容投稿</span>
              <p className="text-sm font-medium text-foreground-800">content@rrtv.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}